/* eslint-disable react/prop-types */
import React from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import * as yup from 'yup';

// uPIID and details form validation schema
const upiidDetailsFormSchema = yup.object().shape({
  upiidSQ: yup
    .string()
    .min(7, 'This field must be 7 characters')
    .max(7, 'This field must be 7 characters')
    .required('This is a required field')
    .matches('^[0-9]{2}[a-zA-Z]{1}[0-9]{4}$', 'Invalid UPIID number'),
  solicitationTitle: yup.string().required('This is a required field'),
  solicitationDescription: yup.string().nullable(),
  solicitationPosting: yup.string().nullable().url('Please enter a valid URL'),
  contractYear: yup.string().required(),
  purchaseType: yup.string().required(),
});

// Form context for create/edit/renew solicitation uPIID and details form
const UpiidDetailsFormContext = ({ solicitation, children }) => {
  const defaultValues = solicitation
    ? { ...solicitation }
    : {
        bidType: 'IN_FLEET',
        contractYear: new Date().getFullYear(),
        purchaseType: 'S',
      };

  const methods = useForm({
    resolver: yupResolver(upiidDetailsFormSchema),
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues,
  });
  return <FormProvider {...methods}>{children}</FormProvider>;
};
export default UpiidDetailsFormContext;
